import React from "react";
import { BRAND } from "../lib/brand";
import { useQuotePopup } from "../context/QuotePopupContext";

export const Footer = () => {
  const { openPopup } = useQuotePopup();
  return (
    <footer className="bg-[#07271E] text-white pt-20 pb-10 border-t border-[#C9A227]/20" data-testid="footer">
      <div className="container-luxury">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-8">
          {/* Brand */}
          <div className="lg:col-span-4">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center border border-[#C9A227] rounded-full">
                <span className="font-serif text-[#C9A227] text-lg leading-none">
                  E
                </span>
              </div>
              <div>
                <div className="font-serif text-white text-xl">{BRAND.name}</div>
                <div className="label-overline text-[#C9A227]/80 text-[0.6rem]">
                  Kerala Plantation Luxury
                </div>
              </div>
            </div>
            <p className="mt-6 text-white/65 font-light leading-relaxed max-w-sm">
              A premium B2B supplier of estate-sourced Kerala green cardamom and
              dry fruits — serving Bangalore's finest distributors, hotels,
              sweet shops and food manufacturers since 2008.
            </p>
            <div className="mt-8 flex items-center gap-3">
              <span className="chip">FSSAI Certified</span>
              <span className="chip">GST Registered</span>
            </div>
          </div>

          {/* Links */}
          <div className="lg:col-span-2">
            <div className="label-overline text-[#C9A227]">Catalogue</div>
            <ul className="mt-5 space-y-3 text-white/70 text-sm font-light">
              {[
                ["Cardamom 6mm+", "products"],
                ["Cardamom 7mm+", "products"],
                ["Cardamom 8mm+", "products"],
                ["Jumbo Grade", "products"],
                ["Dry Fruits", "dryfruits"],
              ].map(([l, id]) => (
                <li key={l}>
                  <button
                    onClick={() =>
                      document
                        .getElementById(id)
                        ?.scrollIntoView({ behavior: "smooth" })
                    }
                    className="hover:text-[#C9A227] transition-colors"
                  >
                    {l}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <div className="label-overline text-[#C9A227]">Company</div>
            <ul className="mt-5 space-y-3 text-white/70 text-sm font-light">
              {[
                ["Why Choose Us", "why"],
                ["Our Process", "journey"],
                ["Industries", "industries"],
                ["Testimonials", "testimonials"],
                ["FAQ", "faq"],
              ].map(([l, id]) => (
                <li key={l}>
                  <button
                    onClick={() =>
                      document
                        .getElementById(id)
                        ?.scrollIntoView({ behavior: "smooth" })
                    }
                    className="hover:text-[#C9A227] transition-colors"
                  >
                    {l}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <div className="label-overline text-[#C9A227]">Trade Desk</div>
            <ul className="mt-5 space-y-3 text-white/70 text-sm font-light">
              <li>
                <a href={`tel:${BRAND.phoneRaw}`} className="hover:text-[#C9A227] transition-colors">
                  {BRAND.phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${BRAND.email}`} className="hover:text-[#C9A227] transition-colors">
                  {BRAND.email}
                </a>
              </li>
              <li className="pt-2">
                {BRAND.address.line1}, {BRAND.address.line2}, {BRAND.address.city}
              </li>
            </ul>
            <button
              onClick={openPopup}
              data-testid="footer-quote-btn"
              className="btn-gold mt-7"
            >
              Get Wholesale Quote
            </button>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/50 text-xs font-light">
            © {new Date().getFullYear()} {BRAND.name}. All rights reserved.
          </p>
          <p className="text-white/40 text-xs font-light italic">
            Crafted with plantation pride · Bangalore
          </p>
        </div>
      </div>
    </footer>
  );
};
